/* ==========================================================================
   THEO & EMMA — Magazin-Artikel (Variante B)
   - Lesefortschritts-Balken
   - Auto-Inhaltsverzeichnis aus H2/H3 + Kapitel-Marker + Scrollspy
   - Einheitliche [ ]-Textmodule:
       [lead]…[/lead]
       [check] -zeilen [/check]
       [quote | Autor]…[/quote]
       [callout | Label]…[/callout]   ·  [callout coral | Label]…[/callout]
       [figure | Bildunterschrift]    ·  [figure float | …]   (direkt nach einem Bild)
   ([shop …] wird serverseitig in Liquid gerendert.)
   Grammatik: [name option | freitext] … [/name]   — keine Anführungszeichen nötig.
   Degradiert sauber: ohne JS bleibt der Artikel les- und kaufbar.
   ========================================================================== */
(function () {
  function init(root) {
    if (!root || root.dataset.magInit === '1') return;
    root.dataset.magInit = '1';

    var body = root.querySelector('[data-mag-body]');

    if (body) {
      var hadLead = transformShortcodes(body); // String-Ebene (innerHTML)
      buildFigures(body);                       // DOM: Bildunterschriften
      buildChapters(body, root.querySelector('[data-mag-toc]')); // H2/H3 → Kapitel
      if (!hadLead) markLead(body);             // Auto-Lead nur ohne [lead]
    }

    var bar = root.querySelector('[data-mag-bar]');
    var tocLinks = Array.prototype.slice.call(root.querySelectorAll('[data-mag-toc] a'));
    var sections = tocLinks
      .map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); })
      .filter(Boolean);

    function onScroll() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      if (bar) bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
      var active = 0;
      sections.forEach(function (s, i) { if (s.getBoundingClientRect().top < 140) active = i; });
      tocLinks.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
    }
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- erster Absatz = Lead (nur falls kein [lead] genutzt) -------- */
  function markLead(body) {
    var p = body.querySelector('p');
    if (p && p.textContent.trim()) p.classList.add('lead');
  }

  /* ---- H2/H3 → Kapitel-Marker + TOC ------------------------------- */
  function buildChapters(body, toc) {
    var heads = body.querySelectorAll('h2');
    if (!heads.length) heads = body.querySelectorAll('h3');
    var n = 0;
    heads.forEach(function (h2) {
      n++;
      var num = ('0' + n).slice(-2);
      var id = h2.id || 's' + n;
      h2.id = id;

      var eyebrowWord = h2.getAttribute('data-eyebrow') || '';
      var chapter = document.createElement('div');
      chapter.className = 'b-chapter';
      var eyebrow = document.createElement('p');
      eyebrow.className = 'b-chapter__eyebrow';
      eyebrow.innerHTML = '<span class="n">' + num + '</span>' +
        (eyebrowWord ? ' ' + escapeHtml(eyebrowWord) : '');
      h2.parentNode.insertBefore(chapter, h2);
      chapter.appendChild(eyebrow);
      chapter.appendChild(h2);

      if (toc) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h2.textContent.trim();
        li.appendChild(a);
        toc.appendChild(li);
      }
    });
    if (toc && n === 0) {
      var widget = toc.closest('[data-mag-toc-widget]');
      if (widget) widget.hidden = true;
    }
  }

  /* ---- Block-Module auf innerHTML wandeln ------------------------- */
  function transformShortcodes(body) {
    var html = body.innerHTML;
    var hadLead = /\[lead\]/i.test(html);

    // [lead] … [/lead]
    html = html.replace(/\[lead\]([\s\S]*?)\[\/lead\]/gi, function (_, inner) {
      return '<p class="lead">' + clean(inner) + '</p>';
    });

    // [check] … [/check]  (Zeilen mit "-" → Karten, erste Aussage fett)
    html = html.replace(/\[check\]([\s\S]*?)\[\/check\]/gi, function (_, inner) {
      var items = listItems(inner);
      if (!items.length) return '';
      var svg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m5 13 4 4L19 7"/></svg>';
      var lis = items.map(function (it) {
        var m = it.match(/^(.*?[.!:])\s+([\s\S]*)$/);
        var head = m ? m[1] : it;
        var rest = m ? m[2] : '';
        return '<li>' + svg + '<span><strong>' + head + '</strong>' + (rest ? ' ' + rest : '') + '</span></li>';
      }).join('');
      return '<ul class="b-check">' + lis + '</ul>';
    });

    // [quote | Autor] … [/quote]
    html = html.replace(/\[quote([^\]]*)\]([\s\S]*?)\[\/quote\]/gi, function (_, attrs, inner) {
      var t = parseTag(attrs);
      var author = t.text;
      var av = initials(author);
      var cite = author
        ? '<cite>' + (av ? '<span class="av">' + av + '</span>' : '') + escapeHtml(author) + '</cite>'
        : '';
      return '<div class="b-quote"><span class="b-quote__mark">„</span>' +
        '<blockquote>' + clean(inner) + '</blockquote>' + cite + '</div>';
    });

    // [callout coral | Label] … [/callout]
    html = html.replace(/\[callout([^\]]*)\]([\s\S]*?)\[\/callout\]/gi, function (_, attrs, inner) {
      var t = parseTag(attrs);
      var mod = /coral/i.test(t.opt) ? ' b-callout--coral' : '';
      var label = t.text || 'Gut zu wissen';
      var icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>';
      return '<div class="b-callout' + mod + '">' +
        '<p class="b-callout__label">' + icon + ' ' + escapeHtml(label) + '</p>' +
        '<p>' + clean(inner) + '</p></div>';
    });

    body.innerHTML = html;
    return hadLead;
  }

  /* ---- [figure | Text] / [figure float | Text] → Bild umschließen - */
  function buildFigures(body) {
    var markers = Array.prototype.slice.call(body.querySelectorAll('p, div'));
    markers.forEach(function (el) {
      var txt = el.textContent.trim();
      var m = txt.match(/^\[figure([^\]]*)\]$/i);
      if (!m) return;
      var t = parseTag(m[1]);
      var floatCls = /float/i.test(t.opt) ? ' b-fig--float' : '';

      var prev = el.previousElementSibling;
      var img = null;
      if (prev) img = (prev.tagName === 'IMG') ? prev : (prev.querySelector ? prev.querySelector('img') : null);
      if (!img) { el.parentNode.removeChild(el); return; }

      var fig = document.createElement('figure');
      fig.className = 'b-fig' + floatCls;
      img.parentNode.removeChild(img);
      fig.appendChild(img);
      if (t.text) {
        var fc = document.createElement('figcaption');
        fc.textContent = t.text;
        fig.appendChild(fc);
      }
      el.parentNode.insertBefore(fig, el);
      el.parentNode.removeChild(el);
      if (prev && prev !== fig && !prev.querySelector('img') && prev.textContent.trim() === '') {
        prev.parentNode.removeChild(prev);
      }
    });
  }

  /* ---- Helfer ----------------------------------------------------- */
  // "[name option | freitext]" → { opt:"option", text:"freitext" }
  function parseTag(rest) {
    rest = rest || '';
    if (rest.indexOf('|') >= 0) {
      var parts = rest.split('|');
      return { opt: parts.shift().trim(), text: parts.join('|').trim() };
    }
    return { opt: rest.trim(), text: '' };
  }

  // Zeilen/<li> aus einem Block holen → Array von Items (führendes -/•/* entfernt)
  function listItems(inner) {
    var text = inner
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/li>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '');
    return text.split('\n').map(function (l) {
      return l.replace(/^\s*[-*•]\s*/, '').trim();
    }).filter(Boolean);
  }

  function initials(name) {
    if (!name) return '';
    var parts = name.replace(/^(Dr\.?|med\.?|vet\.?)\s+/gi, '').split(/[\s·.]+/).filter(Boolean);
    var first = parts[0] ? parts[0][0] : '';
    var last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
  }
  function clean(inner) {
    return inner.replace(/<\/?p[^>]*>/gi, ' ').replace(/\s+/g, ' ').trim();
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function boot() { document.querySelectorAll('[data-mag-article]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-mag-article]');
    if (el) init(el);
  });
})();
